export default "__VITE_ASSET__DXGzbE$v__"